<template>
  <section>
    <div v-if="loading" class="info">{{ $t('common.loading') }}</div>
    <div v-else-if="error" class="error">{{ error }}</div>

    <template v-else>
      <div class="detail">
        <h3>{{ customer.name }}</h3>
        <p>{{ $t('advanced.customers.detail.email_label') }}   <strong>{{ customer.email  || '-' }}</strong></p>
        <p>{{ $t('advanced.customers.detail.phone_label') }} <strong>{{ customer.phone  || '-' }}</strong></p>
        <p>{{ $t('advanced.customers.detail.notes_label') }}  <strong>{{ customer.notes  || '-' }}</strong></p>
      </div>

      <h4>{{ $t('advanced.customers.detail.past_appointments') }}</h4>
      <ul class="list">
        <li v-for="a in appts" :key="a.id">
          {{ fmtDate(a.date) }} – <em>{{ a.expert_name }}</em>
          <small>({{ a.status }})</small>
          <ul class="svc">
            <li v-for="s in a.services" :key="s.service_id">
              {{ s.service_name }} ×{{ s.quantity }}
            </li>
          </ul>
        </li>
        <li v-if="!appts.length">{{ $t('advanced.customers.detail.no_past') }}</li>
      </ul>
    </template>
  </section>
</template>

<script setup>
/* eslint-disable no-undef */
import { ref, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";
import axios from "axios";

const { t } = useI18n();

const props    = defineProps({ customerId:{ type:Number, required:true } });
const customer = ref({});
const appts    = ref([]);
const loading  = ref(false);
const error    = ref(null);

const fetch = async () => {
  loading.value = true;
  try {
    const { data } = await axios.get(`/promo/user/customers/${props.customerId}/past-appointments`);
    customer.value = { name:data.customer_name };  // endpoint’ten gelen
    appts.value    = data.past_appointments;
  } catch {
    error.value = t("advanced.customers.detail.fetch_error");
  } finally {
    loading.value = false;
  }
};
const fmtDate = iso => iso.replace("T"," ").slice(0,16);

onMounted(fetch);
watch(()=>props.customerId, fetch);
</script>

<style scoped>
.detail{ display:flex; flex-direction:column; gap:.4rem; margin-bottom:1rem; }
.list  { margin:0; padding:0; list-style:none; }
.list>li{ margin:.4rem 0; }
.svc   { margin:.2rem 0 .4rem 2rem; list-style:square; font-size:.9em; }
.info,.error{ margin-top:.6rem; }
.error{ color:#f44336; }
h3,h4{ font-weight:600; margin:.2rem 0; }
p{margin: 5px 0;}
</style>
